export var GET_CSRF_TOKEN_URL = "/getrcft";
export var CSRF_HEADER_NAME = '_rcft';
// List of URLs (or patterns) that require CSRF token
export var CSRF_PROTECTED_URLS = [
    "/updateProfile",
    "/changeEmailAddress",
    "/changePassword",
    "/createTeam",
    "/group/rename",
    "/activityLog/add",
    "/sendAttendedInviteEmail",
    "/scheduleAccess/resource/add",
    "/scheduleAccess/resource/update",
    "/scheduleAccess/scheduler/add",
    "/scheduleAccess/scheduler/update",
    "/inviteUser",
    "/reactivateSubUsers",
    "/editUser",
    "/policy/add",
    "/policy/update",
    "/deploypackage/add",
    "/deploypackage/duplicate/add",
    "/sso/configUserSSODetails",
    "/updatePaymentDetails",
    "/subUserRegister/",
    "/paypal/rdp/signup/",
    "/saveRecipientMailIds",
    "/sso/updateUserSSODetails",
    "/attendedAccessDetails",
    "/sendAttendedInviteEmail",
    "/2FA/user/enable",
    "/2FA/user/generatePasscode",
    "/accesscontrol/ip/list",
    "/accesscontrol/ip/add",
    "/account/otp-verify",
    "/cancel",
    "/backup/cancel",
    "/schedule/report/create",
    "/schedule/report/update"
];
